<template>
  <AddPosts />
</template>
<script>
import appConfig from '@/app.config'
import AddPosts from '../../../components/skillup/posts/AddPosts.vue'
export default {
  page: {
    title: 'اضافه کردن پست',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-add-posts',
  components: {
    AddPosts,
  },
}
</script>
